let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e5gca")).then(() => parcelRequire('lnWbi'));